/**
* Image Content Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Content Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase.js';
( function( app ) {
  const COMPONENT = {

    className: 'image-content-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( CustomEase );

      CustomEase.create( 'fastForward', ' 0.390, 0.575, 0.565, 1.000 ' );

      gsap.from( '.image-content-cards .arrows .icon', {
        scrollTrigger: {
          trigger: '.image-content-cards',
          start: 'top 55%',
          scrub: false,
        },
        x: '-100vw',
        duration: 0.9,
        ease: 'fastForward',
        stagger: {
          each: 0.15,
          from: 2,
        },
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-content-cards', COMPONENT );
} )( app );
